var _path, _path2, _path3, _line, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDetails(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 141,
    viewBox: "0 0 128 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5834 127.835H15.8289C10.306 127.835 5.82886 123.358 5.82886 117.835V15.3521C5.82886 9.82925 10.3061 5.35209 15.8289 5.35213L111.951 5.35289C117.474 5.35293 121.951 9.83007 121.951 15.3529V32.3281",
    stroke: "#40465E",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.595 76.1318C122.595 100.789 102.652 120.759 78.0738 120.759C53.4953 120.759 33.5522 100.789 33.5522 76.1318C33.5522 51.4747 53.4953 31.5044 78.0738 31.5044C102.652 31.5044 122.595 51.4747 122.595 76.1318Z",
    stroke: "#40465E",
    strokeWidth: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.929 138.654C116.631 140.828 119.774 141.211 121.948 139.509C124.122 137.806 124.505 134.664 122.803 132.49L114.929 138.654ZM99.5633 119.029L114.929 138.654L122.803 132.49L107.437 112.864L99.5633 119.029Z",
    fill: "#40465E"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 41.7849,
    y1: 96.9609,
    x2: 81.0957,
    y2: 96.9609,
    stroke: "#40465E",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 36.5959,
    y1: 74.7803,
    x2: 81.0957,
    y2: 74.7803,
    stroke: "#40465E",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 44.8894,
    y1: 54.5264,
    x2: 81.0957,
    y2: 54.5264,
    stroke: "#40465E",
    strokeWidth: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails);
export default __webpack_public_path__ + "static/media/Details.7b4e30b511a990572ac1d653dae83555.svg";
export { ForwardRef as ReactComponent };